import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const ActionTypes          = {
    SET_LIGHT_BOX_DATA_THEN_SHOW: 'SET_LIGHT_BOX_DATA_THEN_SHOW',
    SET_CUSTOM_STYLES           : 'SET_CUSTOM_STYLES'
}
Vue.prototype.$ActionTypes = ActionTypes

export default new Vuex.Store({
    state    : {
        scClient             : null,
        scSubscribeChannel   : null,
        clientId             : '',
        clientName           : '',
        clientToken          : '',
        botCode              : '',
        subChannel           : '',
        componentsMainChatBox: null,
        componentsMainApp    : null,
        bot_icon             : '',
        styles               : {
            // header
            headerBackground: 'linear-gradient(86.7deg, #3353a2ff 0.85%, #31b7b7ff 98.94%)',
            headerTextColor: '#ffffffff',
            headerLogoEnable: false,
            headerLogoLink: 'img/Icon-fpt-ai.png',
            headerText: 'Hỗ trợ trực tuyến',
            // main
            primaryColor: '#6d9ccbff',
            secondaryColor: '#ecececff',
            primaryTextColor: '#ffffffff',
            secondaryTextColor: '#000000DE',
            buttonColor: '#b4b4b4',
            buttonColorHover: null,
            buttonOpacityHover: 0.7,
            buttonTextColor: '#ffffffff',
            buttonTextColorHover: null,
            buttonAlign: 'center',
            buttonWeight: 'normal',
            bodyBackgroundEnable: false,
            bodyBackgroundLink: '',
            avatarBot: 'img/bot.png',
            sendMessagePlaceholder: 'Nhập tin nhắn',
            // start screen
            customerLogo: 'img/bot.png',
            customerWelcomeTextColor: '#8d8b91',
            customerWelcomeText: 'Vui lòng nhập tên của bạn',
            customerWelcomeDes: '',
            customerWelcomeDesSize: '',
            customerWelcomeTextSize:'',
            customerWelcomeLinkText: '',
            customerWelcomeLink: '',
            customerWelcomePlaceholder: '',
            customerWarningText: '',
            customerWarningLinkText: '',
            customerWarningLink: '',
            disabledPoweredByLink: false,
            customerTermLink:'',
            customerConfirmCheckbox:'',
            customerButtonText: 'Bắt đầu',
            prefixEnable: false,
            prefixType: 'radio',
            prefixOptions: ['Anh', 'Chị'],
            prefixPlaceholder: 'Danh xưng',
            quickReplyButtonAlign: 'center',
            quickReplyButtonColor: '#b4b4b4',
            quickReplyButtonBorderColor: '#FF5F5F',
            quickReplyButtonColorHover: '#b4b4b4',
            quickReplyButtonBorderColorHover: '#D63838'
        },
        lightBoxData         : [],
        lightBoxIndex        : null,
        customSender         : false,
        rejectIfAuthFailed   : false,
        startPayload         : '',
        suggestionList       : [],
        isChatWithBot        : false,

        // for option enable react button
        reactButtonEnable: false,
    },
    mutations: {
        [ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW]: (state, payload) => {
            if (payload.data && payload.data.length > 0) {
                state.lightBoxData  = [...payload.data]
                state.lightBoxIndex = payload.index || payload.index === 0 ? payload.index : null
            } else {
                state.lightBoxData  = []
                state.lightBoxIndex = null
            }
        },
        [ActionTypes.SET_CUSTOM_STYLES]           : (state, payload) => {
            state.styles = payload
        }
    },
    actions  : {
        [ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW]: (context, payload) => {
            context.commit(ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, payload)
        },
        [ActionTypes.SET_CUSTOM_STYLES]           : (context, payload) => {
            context.commit(ActionTypes.SET_CUSTOM_STYLES, payload)
        }
    }
})
